import gql from 'graphql-tag'

const GET_SHOOT_TYPES = gql`
  query shootTypes($tenantId: Int!, $name: String, $offset: Int, $limit: Int) {
    shootTypes(tenantId: $tenantId, name: $name, offset: $offset, limit: $limit) {
      total
      data {
        id
        name
      }
    }
  }
`

export { GET_SHOOT_TYPES }
